import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { post, put } from "../../../utility/fetch";
import toast from "react-hot-toast";
import TagInputs from "../../inputs/TagInputs";

const Password = ({ prevStep }) => {
    const [password, setPassword] = useState({
        email: "",
        oldPassword: "",
        newPassword: "",
    });

    const checks = {
        hasUppercase: /[A-Z]/.test(password.newPassword),
        hasSpecialChar: /[$#!*()?]/.test(password.newPassword),
        hasNumber: /\d/.test(password.newPassword),
        hasLowercase: /[a-z]/.test(password.newPassword),
    };

    const navigate = useNavigate();

    const updatePassword = async () => {
        const response = await post(`/Auth/reset-password`, password);
        if (response.status == 'success') {
            toast.success("Password updated successfully");
        } else {
            toast.error("Error updating password");
        }
    };

    const handleChange = (field, value) => {
        setPassword({ ...password, [field]: value });
    };

    return (
        <div className="card ">
            <div className="container flex-direction-v">
                <div className="container center-text col-6">
                    <h2 className="m-t-20">Update Password</h2>
                    <TagInputs
                        label="Email"
                        type="email"
                        placeholder="Enter your email"
                        value={password.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                    />
                    <TagInputs
                        label="Old Password"
                        type="password"
                        placeholder="Enter your old password"
                        value={password.oldPassword}
                        onChange={(e) => handleChange("oldPassword", e.target.value)}
                    />
                    <TagInputs
                        label="New Password"
                        type="password"
                        placeholder="Enter your new password"
                        value={password.newPassword}
                        onChange={(e) => handleChange("newPassword", e.target.value)}
                    />
                    <div className="password-checks m-b-20 m-t-20">
                        <label className={checks.hasUppercase ? "valid" : ""}>
                            Password must contain an uppercase letter
                            <input type="checkbox" checked={checks.hasUppercase} readOnly />
                        </label>
                        <label className={checks.hasSpecialChar ? "valid" : ""}>
                            Password must contain a special character ($#!*()?)
                            <input type="checkbox" checked={checks.hasSpecialChar} readOnly />
                        </label>
                        <label className={checks.hasNumber ? "valid" : ""}>
                            Password must contain at least one number
                            <input type="checkbox" checked={checks.hasNumber} readOnly />
                        </label>
                        <label className={checks.hasLowercase ? "valid" : ""}>
                            Password must contain a lowercase letter
                            <input type="checkbox" checked={checks.hasLowercase} readOnly />
                        </label>
                    </div>
                    <button
                        onClick={updatePassword}
                        className="submit-btn m-t-20"
                        disabled={!Object.values(checks).every(Boolean)}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Password;
